import styled from 'styled-components'

import { TextareaProps } from '@customTypes'
import { palette } from '_styles/variables'

export const StyledTextarea = styled.textarea<Pick<TextareaProps, 'hasError'>>`
  font-size: 1em;
  font-weight: 600;
  border: 1px solid;
  border-radius: 0.25rem;
  border-color: ${({ hasError }) =>
    hasError ? palette.ui.error : palette.neutral['grey-bbbdbf']};
  color: ${palette.neutral['primary-body']};
  line-height: 1em;
  box-sizing: border-box;
  resize: none;
  height: 100%;
  padding: 1.125rem 0.75rem;

  &:focus {
    border: 1px solid ${palette.ui.blue};
    outline: none;
  }

  &::placeholder {
    color: ${palette.neutral['grey-bbbdbf']};
  }

  &:disabled {
    background-color: ${palette.neutral['grey-ebebeb']};
  }
`
